const ACTIONS = Object.freeze({
    start: { key: 'start', label: 'Почати читати', icon: 'fa-play', status: 'reading' },
    mark_read: { key: 'mark_read', label: 'Позначити прочитаною', status: 'read' },
    reread: { key: 'reread', label: 'Перечитати', icon: 'fa-redo-alt', status: 'reading' },
    pause: { key: 'pause', label: 'Відкласти', status: 'want_to_read' },
    resume: { key: 'resume', label: 'Продовжити', icon: 'fa-play', status: 'reading' },
    complete: { key: 'complete', label: 'Завершити', icon: 'fa-check', status: 'read' },
    abandon: { key: 'abandon', label: 'Не дочитано', status: 'abandoned' },
    start_over: { key: 'start_over', label: 'Почати заново' },
    retry: { key: 'retry', label: 'Спробувати знову', icon: 'fa-redo-alt', status: 'reading' },
    move_to_want: { key: 'move_to_want', label: 'Хочу прочитати', status: 'want_to_read' },
});

function quickPreviewActionMatrix(context = {}) {
    const allowed = context.actionCapabilities || {};
    const state = context.actionReading?.state || null;
    let primary = null;
    let secondary = null;

    if (allowed.resume) primary = ACTIONS.resume;
    else if (allowed.complete && state === 'active') primary = ACTIONS.complete;
    else if (allowed.reread) primary = ACTIONS.reread;
    else if (allowed.retry) primary = ACTIONS.retry;
    else if (allowed.start) primary = ACTIONS.start;

    if (allowed.pause) secondary = ACTIONS.pause;
    else if (allowed.resume && allowed.complete) secondary = ACTIONS.complete;
    else if (allowed.move_to_want) secondary = ACTIONS.move_to_want;

    const overflow = [];
    if (allowed.start_over) overflow.push(ACTIONS.start_over);
    if (allowed.mark_read) overflow.push(ACTIONS.mark_read);
    if (allowed.abandon) overflow.push(ACTIONS.abandon);

    return { primary, secondary, overflow };
}

function lifecycleRequest(action, item, context) {
    const definition = ACTIONS[action];
    if (!definition) throw new Error(`Unsupported quick-preview action: ${action}`);
    const statusId = context?.readingStatusId;
    const bookId = item?.book?.id;

    if (action === 'start_over') {
        const reading = context?.actionReading;
        return {
            method: 'post',
            url: `/api/reading-status/status/${statusId}/start-over`,
            data: {
                reading_instance_id: reading?.readingInstanceId,
                expected_reading_status_lock_version: context?.readingStatusLockVersion,
                expected_reading_instance_lock_version: reading?.lockVersion,
            },
        };
    }

    return {
        method: 'post',
        url: `/api/reading-status/book/${bookId}`,
        data: {
            status: definition.status,
            lock_version: context?.readingStatusLockVersion,
        },
    };
}

// Deliberate shelf choice uses the same canonical writer as Preview lifecycle
// and Review Detail; there is no separate public-Library status writer.
function shelfChoiceRequest(status, item, context = {}) {
    if (!['want_to_read', 'reading', 'read', 'abandoned'].includes(status)) throw new Error('Unsupported shelf choice');
    return {
        method: 'post',
        url: `/api/reading-status/book/${item?.book?.id}`,
        data: { status, lock_version: context.readingStatusLockVersion ?? null },
    };
}

module.exports = { ACTIONS, lifecycleRequest, shelfChoiceRequest, quickPreviewActionMatrix };
